import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { AuthenticationRoute } from '../Guards/AuthenticationRoute';
import { ProtectedRoute } from '../Guards/ProtectedRoute';
import { AddRestaurantPage } from '@/components/pages/AddRestaurantPage';
import { ClaimApproveRejectPage } from '@/components/pages/ClaimApproveRejectPage';
import { ClaimCheckPage } from '@/components/pages/ClaimCheckPage';
import { ClaimInfoPage } from '@/components/pages/ClaimInfoPage';
import { ClaimPage } from '@/components/pages/ClaimPage';
import { HomePage } from '@/components/pages/HomePage';
import { LoginCheckPage } from '@/components/pages/LoginCheckPage';
import { LoginPage } from '@/components/pages/LoginPage';
import { ModerationClaimPage } from '@/components/pages/ModerationClaimPage';
import { ModerationRestaurantPage } from '@/components/pages/ModerationRestaurantPage';
import { ProfilePage } from '@/components/pages/ProfilePage';
import { BoostReturnPage } from '@/components/pages/Restaurant/BoostReturnPage';
import { CertificatePage } from '@/components/pages/Restaurant/CertificatePage';
import { CodePromoPage } from '@/components/pages/Restaurant/CodePromoPage';
import { EditPage } from '@/components/pages/Restaurant/EditPage';
import { PicturePage } from '@/components/pages/Restaurant/PicturePage';
import { RestaurantInactivePage } from '@/components/pages/Restaurant/RestaurantInactivePage';
import { RestaurantStatsPage } from '@/components/pages/Restaurant/RestaurantStatsPage';
import { SubscriptionPage } from '@/components/pages/Restaurant/SubscriptionPage';
import { SignUpPage } from '@/components/pages/SignUpPage';
import { SignUpValidationPage } from '@/components/pages/SignUpValidationPage';
import { SubscriptionRestoCheckPage } from '@/components/pages/SubscriptionRestoCheckPage';
import { SubscriptionRestoPage } from '@/components/pages/SubscriptionRestoPage';
import { ErrorLayout } from '@/components/templates/ErrorLayout';

export const Router = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route path="login-check" element={<LoginCheckPage />} />
      <Route element={<AuthenticationRoute />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="connexion" element={<LoginPage />} />
        <Route path="signup" element={<SignUpPage />} />
        <Route path="signup-validation" element={<SignUpValidationPage />} />
        <Route path="claim" element={<ClaimInfoPage />} />
        <Route path="claim/:id" element={<ClaimPage />} />
        <Route path="claim/check" element={<ClaimCheckPage />} />
        <Route path="claim/approve-reject" element={<ClaimApproveRejectPage />} />
        <Route path="subscription" element={<SubscriptionRestoPage />} />
        <Route path="subscription/check" element={<SubscriptionRestoCheckPage />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path="" element={<HomePage />} />

        <Route path="proposal-restaurant" element={<AddRestaurantPage />} />
        <Route path="proposal-restaurant/:id" element={<AddRestaurantPage />} />

        <Route path="profile" element={<ProfilePage />} />
        <Route path="not-authorized" element={<ErrorLayout>{t(`page.notAuthorized`)}</ErrorLayout>} />

        <Route path="boost-return" element={<BoostReturnPage />} />

        <Route path="moderation/:id" element={<ModerationRestaurantPage />} />
        <Route path="claim-moderation/:id" element={<ModerationClaimPage />} />

        <Route path="restaurant/:id" element={<EditPage />} />
        <Route path="restaurant/inactive" element={<RestaurantInactivePage />} />
        <Route path="restaurant/stats/:id" element={<RestaurantStatsPage />} />
        <Route path="restaurant/picture/:id" element={<PicturePage />} />
        <Route path="restaurant/code-promo/:id" element={<CodePromoPage />} />
        <Route path="restaurant/certificate/:id" element={<CertificatePage />} />
        <Route path="restaurant/subscription/:id" element={<SubscriptionPage />} />
      </Route>
      <Route path="*" element={<ErrorLayout>{t(`page.notExists`)}</ErrorLayout>} />
    </Routes>
  );
};
